import { IS_APP_IN_IFRAME } from "constants/common.constants";

import { qubictronAppsUrlMap } from "@qubictron/url";
import {
  Assets,
  // Not available in @qubictron/url yet:
  // QUBICTRON_PAYMENT_URL,
  QUBICTRON_SIGN_IN_URL,
  QUBICTRON_SIGN_UP_URL,
} from "@qubictron/url/client";

export {
  createScacIconUrl,
  // Not available in @qubictron/url yet:
  // LOGISTICS_EXPLORER_URL,
  // SHIPPING_REQUEST_URL,
} from "@qubictron/url/client";

export const isAppComDomain = /qubictron\.com$/gi.test(window.location.hostname);

export const SIGN_IN_URL = QUBICTRON_SIGN_IN_URL;
export const SIGN_UP_URL = QUBICTRON_SIGN_UP_URL;
// Not available in @qubictron/url yet:
// export const PAYMENT_URL = QUBICTRON_PAYMENT_URL;

export const appHash = __DEV__ ? new Date().getTime().toString() : __APP_VERSION__;

export const assetsPaths = new Assets({
  appFolder: __APP_FOLDER__,
  hash: appHash,
  originResolverCallbackMap: {
    localhost: () => ({ url: __APP_ORIGIN__ }),
  },
  baseUrl: __PROD__ ? qubictronAppsUrlMap.prod().origin : new URL(window.location.href).origin,
});

export const APP_STYLESHEET_HREF = assetsPaths.css.appBundleBuilder().setSearch(appHash).build();

export const APP_FONTS_STYLESHEET_HREF = assetsPaths.css.fonts.bundleBuilder().setSearch(appHash).build();

export const APP_FONTS_REGISTER_STYLESHEET_HREF = assetsPaths.css.fonts
  .bundleRegisterBuilder()
  .setSearch(appHash)
  .build();

export const isAppIntegration = (() => {
  const checkIsAppIntegrated = (url: string): boolean => !/.*qubictron.*/gi.test(url);

  if (__LOCAL__) {
    return false;
  }

  // in iframe
  if (IS_APP_IN_IFRAME) {
    return checkIsAppIntegrated(new URL(document.referrer).origin);
  }

  // without iframe
  return checkIsAppIntegrated(new URL(window.location.href).origin);
})();
